import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { Component, OnInit, Input, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-text-area',
  templateUrl: './text-area.component.html',
  styleUrls: ['./text-area.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: TextAreaComponent,
      multi: true,
    },
  ]
})
export class TextAreaComponent implements OnInit, ControlValueAccessor {

  @ViewChild('textarea', { static: true }) textarea: ElementRef;
  @Input() forcedEnabledMode: string = null;
  @Input() width: number | string;
  @Input() height: number | string;
  @Input() subid: string = null;
  @Input() text: string = <string>'';
  @Input() maxChars: number = null;
  @Input() restrict: string = null;
  @Input() fullOnly: boolean = <boolean>false;
  @Input() halfOnly: boolean = <boolean>false;
  @Input() allowMultiLine: boolean = <boolean>true;
  @Input() toUpperCase: boolean = <boolean>false;
  @Input() editable: boolean = <boolean>true;
  @Input() tabEnabled: boolean = <boolean>true;
  @Input() tabindex: number = null;
  @Input() verticalScrollPolicy: string = <string>'auto';
  @Input() horizontalScrollPolicy: string = <string>'auto';
  @Input() displayCountField: boolean = <boolean>true;
  @Input() counterWidth: string;
  @Input() disabled: boolean = <boolean>false;
  @Output() blur: EventEmitter<any> = new EventEmitter<any>();
  @Output() focus: EventEmitter<any> = new EventEmitter<any>();
  count: string = null;
  private pos: number = <number>0;

  constructor(
    public elementRef: ElementRef
  ) { }

  ngOnInit(): void {
    this.redraw();
    this.textarea.nativeElement.setAttribute('id', `${this.subid}_sub`);
    this.textarea.nativeElement.setAttribute('forcedEnabledMode', this.forcedEnabledMode);
    if (this.displayCountField && this.counterWidth && !this.width) {
      this.width = `calc(100% - ${this.counterWidth}`;
    }
  }

  onChange(_: any): void { }
  onTouched(): void { }
  writeValue(text: string): void {
    if (text !== this.text) {
      this.text = text;
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  private redraw(): void {
    if (this.displayCountField) {
      this.count = this.text.length.toString().padStart(this.maxChars.toString().length, '0');
    }
  }

  textChanged(): void {
    this.redraw();
  }

  setVerticalScrollPolicy(): string {
    if ('auto' === this.verticalScrollPolicy) {
      return this.verticalScrollPolicy;
    }
    else if ('on' === this.verticalScrollPolicy) {
      return 'scroll';
    }
    else if ('off' === this.verticalScrollPolicy) {
      return 'hidden';
    }
    else {
      return null;
    }
  }

  setHorizontalScrollPolicy(): string {
    if ('auto' === this.horizontalScrollPolicy) {
      return this.horizontalScrollPolicy;
    }
    else if ('on' === this.horizontalScrollPolicy) {
      return 'scroll';
    }
    else if ('off' === this.horizontalScrollPolicy) {
      return 'hidden';
    }
    else {
      return null;
    }
  }

  onFocusIn(): void {
    this.textarea.nativeElement.setSelectionRange(this.pos, this.pos);
  }

  onFocusOut(): void {
    this.pos = this.textarea.nativeElement.selectionStart;
  }

  setFocus() {
    this.textarea.nativeElement.focus();
  }
}
